import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import './BannerLogo.sass'

const BannerLogo = ({prefix, suffix}) => (
  <Link className="banner-logo" to="/">
    <h2 className="banner-logo__prefix">{prefix}<span className="banner-logo__suffix">{suffix}</span></h2>
  </Link>
)

BannerLogo.propTypes = {
  prefix: PropTypes.string,
  suffix: PropTypes.string
}

BannerLogo.defaultProps = {
  prefix: 'ИС',
  suffix: 'Услуги'
}

export default BannerLogo



// WEBPACK FOOTER //
// ./components/BannerLogo/index.jsx